<template>
    <div class="purchase-options-form">
        <template class="top">
            <div
                    class="purchase-options-container failable loadable"
                    :class="{loading: purchaseOptionsToShow.loading, failed: purchaseOptionsToShow.error}"
            >
                <template v-if="purchaseOptionsToShow.data">
                    <PurchaseOption
                            v-for="purchaseOption in purchaseOptionsToShow.data"
                            :key="purchaseOption.id"
                            :purchaseOption="purchaseOption"
                            :showCurrency="showCurrency"
                            :selected="purchaseOption === purchaseOptionActive"
                            @selected="selectedPurchaseOptionHandler"
                    />
                    <template v-if="purchaseOptionsToShow.data.length === 0">
                        <template v-if="code">
                            <h5 class="no-purchase-options">
                                {{$t('subscription.promotional_code.invalid', {code: code})}}
                            </h5>
                        </template>
                        <template v-else-if="referal">
                            <h5 class="no-purchase-options">
                                {{$t('subscription.referal_code.invalid')}}
                            </h5>
                        </template>
                        <template v-else>
                            <h5 class="no-purchase-options">
                                {{$t('subscription.no_plans_available')}}
                            </h5>
                            <div class="buttons">
                                <router-link class="btn btn-back" :to="{name: 'home'}">
                                    {{$t('subscription.buttons.back')}}
                                </router-link>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <button
                                type="button"
                                class="subscription-btn"
                                :class="{active: purchaseOptionActive}"
                                @click.prevent="selectedPurchaseOptionHandler(purchaseOptionActive)"
                        >
                            {{$t('subscription.buttons.start_membership')}}
                        </button>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
    import Spinner from "./Spinner";
    import Plan from './SubscriptionForm.Plan';
    import Purchase from './SubscriptionForm.Purchase';
    import PurchaseOption from './SubscriptionForm.PurchaseOption';

    export default {
        components: {
            Spinner,
            Plan,
            Purchase,
            PurchaseOption,
        },
        props: {
            showCurrency: {
                required: true,
            },
            code: {
                required: false,
                default: null,
            },
            referal: {
                required: false,
                default: null,
            },
            purchaseOptions: {
                required: false,
                default(){
                    return null;
                },
            }
        },
        data(){
            return {
                purchaseOptionsToShow: {
                    data: this.purchaseOptions,
                    loading: false,
                    error: false,
                },
                purchaseOptionActive: null,
            }
        },
        methods: {
            selectedPurchaseOptionHandler(purchaseOption){
                if(this.purchaseOptionActive === purchaseOption){
                    this.$emit('purchaseOptionSelected', purchaseOption);
                }else{
                    this.purchaseOptionActive = purchaseOption;
                }
            },
        },
        mounted(){
            if(this.purchaseOptionsToShow.data && this.purchaseOptionsToShow.data.length === 1){
                this.purchaseOptionActive = this.purchaseOptionsToShow.data[0];
            }
        }
    }
</script>
<style scoped lang="scss">
    @import './../styles/variables';
    @import './../styles/classes';

    .buttons{
        text-align: center;
    }

    .btn-back{
        @extend %fresh-btn;
        display: inline-block;
    }

    .subscription-btn{
        @extend %fresh-btn;
        width: auto;
        margin: 2em auto;
        min-height: 70px;
        max-width: 15em;
        cursor: not-allowed;
        font-size: 1.5em;

        &.active{
            background-color: rgba($pallete_main_color, 0.75);
            cursor: pointer;

            &:hover{
                background-color: rgba($pallete_main_color, 0.95);
            }
        }
    }

    .purchase-options-form-container{
        margin-top: 1em;
        margin-bottom: 1em;

        .top{
            min-height: 200px;
        }
    }

    .purchase-options-container{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        min-height: 200px;
        flex: 0;

        .failed-wrapper{
            text-align: center;
        }

        .no-purchase-options{
            display: block;
            margin: auto;
            text-align: center;
            max-width: 300px;
        }

        .purchase-options-block{
            @media(max-width: 600px){
                width: 100%;
            }
        }
    }
</style>